import { useState, useCallback } from 'react';
import { varAlpha } from 'minimal-shared/utils';

import { Box, Tab, Tabs } from '@mui/material';

import { t } from 'src/utils/helper';

import { UserRegister } from '../user-register';
import { CompanyRegister } from '../company-register';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const TAB_OPTIONS = [
  { value: 'individual', label: 'Individual' },
  { value: 'company', label: 'Company' },
];
export function RegisterView({
  open,
  registerUser,
  registerCompany,
  isUserRegisterLoading,
  isCompanyRegisterLoading,
}) {
  const [currentTab, setCurrentTab] = useState('individual');

  const handleChangeTab = useCallback(
    (event, newValue) => {
      setCurrentTab(newValue);
    },
    [setCurrentTab]
  );

  return (
    <Box>
      <Tabs
        value={currentTab}
        onChange={handleChangeTab}
        sx={[
          (theme) => ({
            px: 2.5,
            boxShadow: `inset 0 -2px 0 0 ${varAlpha(theme.vars.palette.grey['500Channel'], 0.08)}`,
          }),
        ]}
      >
        {TAB_OPTIONS.map((tab) => (
          <Tab
            key={tab.value}
            iconPosition="end"
            value={tab.value}
            label={t(tab.label)}
            {...a11yProps(tab.value)}
          />
        ))}
      </Tabs>
      <CustomTabPanel value={currentTab} index="individual">
        <UserRegister registerUser={registerUser} loading={isUserRegisterLoading} />
      </CustomTabPanel>
      <CustomTabPanel value={currentTab} index="company">
        <CompanyRegister registerCompany={registerCompany} loading={isCompanyRegisterLoading} />
      </CustomTabPanel>
    </Box>
  );
}
